module.exports = __webpack_public_path__ + "img/5.ba00f45c.png";